import React from "react";
import { Modal, Button, Checkbox } from "antd";

export const SplashComponent = props => {
  const {
    language,
    visible,
    handleOk,
    splashFrameUrl,
    onCheckboxChange
  } = props;
  const defaultChecked =
    localStorage.getItem("showSplashMobile") &&
    localStorage.getItem("showSplashMobile") == "false";
  return (
    <div id="splashContainer">
      <Modal
        title={language.data.help}
        visible={visible}
        onCancel={handleOk}
        className="splash--mobile--container"
        footer={
          <Button type="primary" onClick={handleOk}>
            {language.data.ok}
          </Button>
        }
      >
        <iframe src={splashFrameUrl} />
        <Checkbox
          style={{ position: "absolute", bottom: "17px", left: "10px" }}
          defaultChecked={defaultChecked}
          onChange={onCheckboxChange}
        >
          {language.data.doNotShowAgain
            ? language.data.doNotShowAgain
            : "Do not show again"}
        </Checkbox>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Mobile/Splash/SplashComponent.js